import { TabIndicatorLevel } from 'shared/entities/managerNotifications';

/**
 * Safari может использовать apple-touch-icon для иконки вкладки, поэтому при
 * изменении уровня индикатора обновляются оба типа иконок.
 */
const FAVICON_SELECTOR = "link[rel='icon'], link[rel='apple-touch-icon']";

/**
 * Для каждого размера подготовлены четыре варианта иконки:
 * без индикатора и с индикаторами уровней neutral, warning и violation.
 */
const FAVICON_HREFS_BY_SIZE: Record<
  string,
  Record<TabIndicatorLevel, string>
> = {
  '16x16': {
    [TabIndicatorLevel.none]: '/favicons/favicon-16x16.png',
    [TabIndicatorLevel.neutral]: '/favicons/favicon-16x16-neutral.png',
    [TabIndicatorLevel.warning]: '/favicons/favicon-16x16-warning.png',
    [TabIndicatorLevel.violation]: '/favicons/favicon-16x16-violated.png'
  },
  '32x32': {
    [TabIndicatorLevel.none]: '/favicons/favicon-32x32.png',
    [TabIndicatorLevel.neutral]: '/favicons/favicon-32x32-neutral.png',
    [TabIndicatorLevel.warning]: '/favicons/favicon-32x32-warning.png',
    [TabIndicatorLevel.violation]: '/favicons/favicon-32x32-violated.png'
  },
  '180x180': {
    [TabIndicatorLevel.none]: '/favicons/apple-touch-icon.png',
    [TabIndicatorLevel.neutral]: '/favicons/apple-touch-icon-neutral.png',
    [TabIndicatorLevel.warning]: '/favicons/apple-touch-icon-warning.png',
    [TabIndicatorLevel.violation]: '/favicons/apple-touch-icon-violated.png'
  }
};

const getFaviconLinks = (): HTMLLinkElement[] =>
  Array.from(document.querySelectorAll<HTMLLinkElement>(FAVICON_SELECTOR));

/**
 * Замена самого link-элемента нужна для Safari: простого изменения href у уже
 * существующего элемента может быть недостаточно, чтобы вкладка обновила icon.
 */
const replaceFaviconLink = (link: HTMLLinkElement, href: string): void => {
  const replacement = link.cloneNode(true) as HTMLLinkElement;
  replacement.href = href;

  if (link.parentNode) {
    link.parentNode.replaceChild(replacement, link);
    return;
  }

  link.href = href;
};

export const setFaviconIndicator = (level: TabIndicatorLevel): void => {
  getFaviconLinks().forEach((link) => {
    const href = FAVICON_HREFS_BY_SIZE[link.sizes.value]?.[level];

    if (href) {
      replaceFaviconLink(link, href);
    }
  });
};
